import * as _ from 'lodash';

const evolve = _.curry((transformations, obj) =>
  _.mapValues(obj, (value, key) => {
    const transformation = transformations[key];
    if (_.isFunction(transformation)) {
      return transformation(value);
    }
    if (_.isObject(transformation)) {
      return evolve(transformation, value);
    }
    return value;
  })
);

export { evolve };
